import {defineNuxtPlugin} from '#app';
import {SanityImage} from '~/components/custom-elements/sanity-image/sanity-image';

export default defineNuxtPlugin(() => {
	customElements.define('sanity-image', SanityImage);
});
